import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    index: Number,
    forDay: String,
    mealtimes: Array
  }

  static targets = ["form", "caloriesValue", "dietValue"]

  connect() {
    // Parse mealtimes if it's a JSON string
    if (typeof this.mealtimesValue === 'string') {
      try {
        this.mealtimesValue = JSON.parse(this.mealtimesValue)
      } catch (e) {
        console.error('Error parsing mealtimes:', e)
        this.mealtimesValue = []
      }
    }
  }

  // Normalizar mealtime como Rails parameterize.underscore
  // Convierte "Media mañana" a "media_manana"
  normalizeMealtime(mealtime) {
    return mealtime
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Eliminar acentos
      .replace(/[^a-z0-9\s]/g, '') // Eliminar caracteres especiales
      .trim()
      .replace(/\s+/g, '_') // Reemplazar espacios con guiones bajos
  }

  handleReplicate(event) {
    event.preventDefault()

    const index = this.indexValue
    const forDay = this.forDayValue

    // Capturar el valor de calorías del día seleccionado
    const caloriesField = document.getElementById(`suggested_calories_${forDay}`)
    if (!caloriesField) {
      console.error(`No se encontró el campo de calorías: suggested_calories_${forDay}`)
      alert('Error: No se pudo encontrar el campo de calorías')
      return false
    }

    const caloriesValue = caloriesField.value
    
    // Establecer el valor en el campo oculto
    const caloriesHiddenField = document.getElementById(`calories_value_${index}`)
    if (caloriesHiddenField) {
      caloriesHiddenField.value = caloriesValue
    }

    // Capturar los valores de las colaciones del día seleccionado
    let allValuesCaptured = true
    this.mealtimesValue.forEach((mealtime) => {
      const dietId = `suggested_diet_${forDay}_${mealtime}`
      const dietField = document.getElementById(dietId)

      if (dietField) {
        const dietValue = dietField.value
        
        // Normalizar mealtime como Rails parameterize.underscore
        const mealtimeKey = this.normalizeMealtime(mealtime)
        const dietHiddenField = document.getElementById(`diet_${mealtimeKey}_${index}`)
        if (dietHiddenField) {
          dietHiddenField.value = dietValue
        } else {
          console.warn(`No se encontró el campo oculto para: diet_${mealtimeKey}_${index}`)
        }
      } else {
        console.warn(`No se encontró el campo para: ${dietId}`)
        allValuesCaptured = false
      }
    })

    if (!allValuesCaptured) {
      console.warn('Algunos valores no se pudieron capturar')
    }

    // Mostrar confirmación
    const confirmed = confirm('¿Está seguro que desea replicar las calorías y colaciones de este día al resto de la semana? Esta acción sobrescribirá los datos de los demás días.')

    if (confirmed) {
      // Enviar el formulario
      const form = document.getElementById(`replicate_form_${index}`)
      if (form) {
        form.submit()
      }
    }

    return false
  }
}

